import { useQuery } from '@tanstack/react-query';

import { customFetch } from '@/service/commonFetch';
import {
  MemulItemType,
  MemulListCountType,
  MemulListParamsType,
  MemulListType,
  SameMemulListType,
} from '@/service/commonType';
import queryKeyFactory from '@/service/queryKeyFactory';
import useInfinityBigHook from '@/utils/hooks/useInfinityBigHook';

/** @description 매물리스트 */
export const useMemulList = (params: MemulListParamsType) => {
  return useInfinityBigHook<MemulItemType>({
    queryFn: {
      queryKey: queryKeyFactory.memul.list(params),
      queryFn: ({ pageParam }: { pageParam: number }) =>
        customFetch<MemulListType>(`/offerings`, {
          params: { page: pageParam, ...params },
        }),
    },
    isSuspense: true,
  });
};

/** @description 매물리스트 카운트 */
export const useMemulListCount = (params: MemulListParamsType) => {
  return useQuery({
    queryKey: queryKeyFactory.memul.listCount(params),
    queryFn: () =>
      customFetch<MemulListCountType>(`/offerings/count`, {
        params,
      }),
    enabled: !!params.bjdCd,
    select: (data) => data.data.count,
  });
};

/** @description 동일매물 리스트 */
export const useMemulSameList = (sameSeq: number, options: any) => {
  return useQuery({
    queryKey: queryKeyFactory.memul.sameList(sameSeq),
    queryFn: () =>
      customFetch<SameMemulListType>(`/offerings/same`, {
        params: { sameSeq },
      }),
    select: (data: SameMemulListType) => data.data.items,
    ...options,
  });
};
